'use strict';
var parent = require('../../actual/array/includes');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/array/includes.js
// module id = 359
// module chunks = 0